import {get, post} from '../interceptor'
let preUrl = '/sys';

export default {
  loginIn (params) { return post(preUrl, '/login', params); },
  getSensorTree (params) { return post(preUrl, '/getSensorTree?mediaId=' + params); },
  getRootSensorTree (params) { return post(preUrl, '/getRootSensorTree?mediaId=' + params); },
  getGatewayTree (params) { return post(preUrl, '/getGatewayTree', params); },
  getBuildTree (params) { return post(preUrl, '/getBuildTree', params); },
  getSiteTree (params) { return post(preUrl, '/getSiteTree', params); },
  getTransferTree (params) { return post(preUrl, '/getTransferTree', params); },
  getSensorList (params) { return post(preUrl, '/getSensorList', params); },
  getSensorData (params = '') { return post(preUrl, '/getSensorData?sensorId=' + params); },
  getLimitType (params) { return post(preUrl, '/getLimitType', params); },
  getMediaList(params) { return post(preUrl, '/getMediaList', params); },
  getPermTree(params) { return post(preUrl, '/getPermTree', params); },
  getRoleList(params) { return post(preUrl, '/getRoleList', params); },
  getUseList(params) { return post(preUrl, '/getUseList', params); },
  getSiteList(params) { return post(preUrl, '/getSiteList', params); },
  /** 建筑管理接口 **/
  getBuildInfo(params) { return post(preUrl, 'Building/getBuildInfo', params); },
  getBuildList(params) { return post(preUrl, 'Building/getBuildList', params); },
  checkBuildName(params) { return get(preUrl, 'Building/checkBuildName', params); },
  addBuildInfo(params) { return post(preUrl, 'Building/addBuildInfo', params); },
  updateBuildInfo(params) { return post(preUrl, 'Building/updateBuildInfo', params); },
  deleteBuildInfo(params) { return post(preUrl, 'Building/deleteBuildInfo', params); },
  /** 分项设置接口 **/
  getClassInfo(params) { return post(preUrl, 'UseClass/getClassInfo', params); },
  addClassInfo(params) { return post(preUrl, 'UseClass/addClassInfo', params); },
  updateClassInfo(params) { return post(preUrl, 'UseClass/updateClassInfo', params); },
  deleteClassInfo(params) { return post(preUrl, 'UseClass/deleteClassInfo', params); },
  checkUseName(params) { return get(preUrl, 'UseClass/checkUseName', params); },
  /** 分项设置接口 **/
  getSysUser(params) { return post(preUrl, 'User/getSysUser', params); },
  addSysUser(params) { return post(preUrl, 'User/addSysUser', params); },
  updateSysUser(params) { return post(preUrl, 'User/updateSysUser', params); },
  deleteSysUser(params) { return post(preUrl, 'User/deleteSysUser', params); },
  checkUserAccount(params) { return get(preUrl, 'User/checkUserAccount', params); },
  resetPsw(params) { return get(preUrl, 'User/resetPsw?id=' + params); },
  changePsw(params) { return post(preUrl, 'User/changePsw', params); },
  getSysRole(params) { return post(preUrl, 'User/getSysRole', params); },
  addSysRole(params) { return post(preUrl, 'User/addSysRole', params); },
  updateSysRole(params) { return post(preUrl, 'User/updateSysRole', params); },
  deleteSysRole(params) { return post(preUrl, 'User/deleteSysRole', params); },
  checkRoleName(params) { return get(preUrl, 'User/checkRoleName', params); },
  getRoleMenu(params) { return post(preUrl, 'User/getRoleMenu', params); },
  /** 电价设置接口 **/
  getEnergyPrice(params) { return post(preUrl, 'Price/getEnergyPrice', params) },
  updateEnergyPrice(params) { return post(preUrl, 'Price/updateEnergyPrice', params) },
  /** 环保因子设置接口 **/
  getSiteProtect(params) { return post(preUrl, 'Protect/getSiteProtect', params) },
  updateSiteProtect(params) { return post(preUrl, 'Protect/updateSiteProtect', params) },
  /** 需求侧响应单价设置接口 **/
  getSiteDemand(params) { return post(preUrl, 'Protect/getSiteDemand', params) },
  updateSiteDemand(params) { return post(preUrl, 'Protect/updateSiteDemand', params) },
  /** 碳排放配额设置接口 **/
  getSiteCarbonLimit(params) { return post(preUrl, 'Protect/getSiteCarbonLimit', params) },
  updateSiteCarbonLimit(params) { return post(preUrl, 'Protect/updateSiteCarbonLimit', params) },
  /** 产值设置接口 **/
  getSiteProdValue(params) { return post(preUrl, 'Protect/getSiteProdValue', params) },
  updateSiteProdValue(params) { return post(preUrl, 'Protect/updateSiteProdValue', params) }
}



// WEBPACK FOOTER //
// ./src/api/energy/systemManage.js